exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3u-gb-Czndj_IS0MxsVhoq {\n  margin: 2px;\n}\n._3u-gb-Czndj_IS0MxsVhoq ._3q32xNv99cdcmwifdZGYxd {\n  display: inline-block;\n  padding-left: 4px;\n}\n", ""]);
// Exports
exports.locals = {
	"base": "_3u-gb-Czndj_IS0MxsVhoq",
	"label": "_3q32xNv99cdcmwifdZGYxd"
};